import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import BankAccountsDirectoryPage from './BankAccountsDirectoryPage.vue'

export const bankAccountsDirectoryRoutes: RouteRecordRaw[] = [
  {
    path: routes.TREASURY_BANK_ACCOUNTS_DIRECTORY,
    name: 'treasury.bankAccountsDirectory',
    component: BankAccountsDirectoryPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'Investor bank accounts',
      activeMenu: 'Treasury',
    },
  },
]
